import { Notification } from "element-ui";
import cookies from "vue-cookies";

var socket = null; //实例对象
var isSocketConnect = false; //是否连接
// var lockReconnect = false; //是否真正建立连接
var timeout = 10 * 1000; //10秒一次心跳
// var timeoutObj = null; //心跳倒计时
// var serverTimeoutObj = null; //服务心跳倒计时
var timeoutnum = null; //断开 重连倒计时
var socketClientTimer = null; //socket连接定时器
var socketHeartTimer = null; //心跳定时器

const connectSocket = () => {
  checkLoginUserSocket();
  socketClientTimer = setTimeout(function() {
    checkLoginUserSocket();
  }, 5000);
};

const checkLoginUserSocket = () => {
  var userId = cookies.get("userid");
  if (userId) {
    if (!isSocketConnect) {
      console.log("------用户登录-连接socket------");
      initWebSocket();
    }
  } else {
    console.log("-----用户未登录--关闭socket");
    close();
  }
};

// 定义一个异步函数，用于初始化WebSocket连接
const initWebSocket = async () => {
  // 判断浏览器是否支持WebSocket
  if ("WebSocket" in window) {
    // 定义WebSocket连接的URL
    const wsUrl = "wss://www.zhiyefangdong.com:8484";
    // 创建WebSocket连接
    socket = new WebSocket(wsUrl);
    // 设置WebSocket连接的错误处理函数
    socket.onerror = webSocketOnError;
    // 设置WebSocket连接的消息处理函数
    socket.onmessage = webSocketOnMessage;
    // 设置WebSocket连接的关闭处理函数
    socket.onclose = closeWebsocket;
    // 设置WebSocket连接的打开处理函数
    socket.onopen = openWebsocket;
  } else {
    // 如果浏览器不支持WebSocket，则弹出错误提示
    Notification.error({
      title: "错误",
      message: "您的浏览器不支持websocket，请更换Chrome或者Firefox",
    });
  }
};

//建立连接
const openWebsocket = (e) => {
  if (socket.readyState == 1) {
    //心跳检测重置
    startHeart();
    //连接成功
    isSocketConnect = true;
  } else {
    console.log("------websocket连接失败------");
  }
};

const startHeart = () => {
  //开启心跳
  if (isSocketConnect) {
    socketHeartTimer = setTimeout(function() {
      console.log("-----心跳监听-----");
      socket.send("heartbeat");
    }, timeout);
  } else {
    clearTimeout(socketHeartTimer);
  }
};

//重新连接
// 定义一个reconnect函数，用于重新连接
const reconnect = () => {
  console.log(isSocketConnect, new Date(), "----重连");
  if (isSocketConnect) {
    return;
  }
  isSocketConnect = true;
  //没连接上会一直重连，设置延迟避免请求过多
  socketHeartTimer && clearTimeout(socketHeartTimer);
  timeoutnum && clearTimeout(timeoutnum);
  timeoutnum = setTimeout(function() {
    //新连接
    console.log("-----重新连接------");
    connectSocket();
    isSocketConnect = false;
  }, 1000);
};

//重置心跳
const reset = () => {
  console.log("------重置心跳------");
  //清除时间
  clearTimeout(socketHeartTimer);
  //   clearTimeout(serverTimeoutObj);
  //重启心跳
  startHeart();
};

const sendWebsocket = (e) => {
  // socket.send(`我发消息了`);
  socket.send(e);
};

const webSocketOnError = (e) => {
  console.log("------连接错误------");
  connectSocket();
  reconnect();
};

//服务器返回的数据
const webSocketOnMessage = (e) => {
  //window自定义事件[下面有说明]
  // console.log(JSON.parse(e.data));
  window.dispatchEvent(
    new CustomEvent("onmessageWS", {
      detail: {
        data: JSON.parse(e.data),
      },
    })
  );
};

const closeWebsocket = (e) => {
  console.log(new Date(), "------断开连接------");
  isSocketConnect = false;
  reconnect();
};

//断开连接
const close = () => {
  console.log("------关闭连接------");
  //WebSocket对象也有发送和关闭的两个方法，只需要在自定义方法中分别调用send()和close()即可实现。
  if (isSocketConnect) {
    // 标识socket已断开
    isSocketConnect = false;
    // 关闭socket连接
    socket.close();
    // 关闭socket心跳定时器
    clearTimeout(socketHeartTimer);
    clearTimeout(socketClientTimer);
  }
};
//具体问题具体分析,把需要用到的方法暴露出去
export default { connectSocket, sendWebsocket, webSocketOnMessage, close };
